import { RSAA } from "redux-api-middleware";
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from "../../config/ApiConstants";

export function assessmentdetailsAPI_Action(token, questionBankId, groupId) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/assessment/${questionBankId}/details`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: "Bearer " + token,
        groupId: groupId
      },
      body: "",
      types: [
        types.ASSESSMENT_DETAILS_REQUEST,
        types.ASSESSMENT_DETAILS_RECEIVE,
        {
          type: types.ASSESSMENT_DETAILS_FAILURE,
          meta: (action, state, res) => {
            return action, state, res;
          },
        },
      ],
    },
  };
}

export const resetassessmentdetailsAPI_Action = () => {
  return {
    type: types.RESET_ASSESSMENT_DETAILS,
    payload: null,
  };
};
